import prevSvg from '../../../assets/svg/arrow-left-dgreen.svg';
import nextSvg from '../../../assets/svg/arrow-left-green.svg';

export default Array.from( document.querySelectorAll( '.feeds.feeds--slider' ) ).map( ( feeds ) => {
	const wrap   = feeds.querySelector('.feeds__wrap');
	const items  = feeds.querySelector('.feeds__items');
	const slides = Array.from( feeds.querySelectorAll('.feeds__item') );
	wrap.classList.add('swiper-container');
	items.classList.add('swiper-wrapper');
	slides.forEach(feed => feed.classList.add('swiper-slide'));
    if (slides.length) {
        feeds.insertAdjacentHTML(
            'beforeend',
           
               ` 
				<div class="swiper-button-prev">${prevSvg}</div>
                <div class="swiper-button-next">${nextSvg}</div>
				
				<nav class="feeds__pagination"></nav>`
           
        );
    }
	
	return new window.Swiper( wrap, {
		direction: 'horizontal',
		// effect: 'fade',
		autoHeight: false,
		speed: 600,
		spaceBetween: 30,
        slidesPerView: 3,
		navigation: {
			prevEl: '.swiper-button-prev',
			nextEl: '.swiper-button-next',
		},
		// pagination: {
		// 	el: ".feeds__pagination",
		// 	clickable: true,
		// },
        keyboard: true,
		breakpoints: {
            768: {
                slidesPerView: 1,
                spaceBetween: 10
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 20
            }
        },
	} );
} );